import React, { useContext } from 'react'

import Page from '../../components/Page'
import UserMetricsReport from '../../components/sections/reportBuilder/reports/UserMetricsReport'
import AuthContext from '../../utils/authProvider'

const UserMetricsReportPage = () => {
  const breadcrumb = [
    {
      path: '/',
      breadcrumbName: 'Home'
    },
    {
      path: '',
      breadcrumbName: 'User Metrics Report'
    }
  ]
  const Auth = useContext(AuthContext)
  const isSuperAdmin = Auth.hasRole('SUPER_ADMIN')
  return (
    <>
      <Page title='User Metrics Report' breadcrumb={breadcrumb}>
        <UserMetricsReport />
      </Page>
    </>
  )
}

export default UserMetricsReportPage
